import { Map } from 'immutable';

// Снимаем маржу с коэффициентов
const deMargin = (bets) => {
  const margin = (bets.reduce((acc, bet) => acc + (1 / bet.price), 0) - 1) / bets.size;

  return bets.map((bet) => 1 / (1 / bet.price - margin));
};

/**
 * Get the most balanced `stakeId` by price.
 *
 * @param {Immutable.Map<number, Stake>} stakes
 * @param {Immutable.Map<number, Bet>} bets
 * @return {number|null} stakeId
 */
export default function getMatchLineStakeId(stakes, bets) {
  let min = Number.POSITIVE_INFINITY;

  return stakes.reduce((stakeId, stake) => {
    if (stake.bets.size === 0) {
      return null;
    }

    const stakeBets = stake.bets.reduce((acc, betId) => {
      if (betId) {
        const bet = bets.get(betId);

        if (bet && bet.isOpen) {
          return acc.set(bet.key, bet);
        }
      }

      return acc;
    }, Map()).toList();

    const betCount = Math.max(2, stake.bets.size);

    deMargin(stakeBets).forEach((odd) => {
      const test = Math.abs(1 / odd - 1 / betCount);

      if (test < min) {
        min = test;
        stakeId = stake.id;
      }
    });

    return stakeId;
  }, null);
}
